import listQuery from 'graphql/queries/system/SystemFolderList.graphql';
import menuQuery from 'graphql/queries/system/SystemMenuList.graphql';
import multiUpdate from 'graphql/mutations/system/SystemFolderAndScreenMutation.graphql';
import mutationQuery from 'graphql/mutations/system/SystemFolderMutation.graphql';
import fragment from 'graphql/fragments/system/SystemFolderFragment.graphql';

const SystemFolder = {
  type: 'SystemFolder',
  title: 'Folders',
  formTitle: 'Folder',
  list: listQuery,
  menuList: menuQuery,
  update: mutationQuery,
  multiUpdate: multiUpdate,
  fragment,
};

export default SystemFolder;
